const planComparisonData = [
  {
    id: 1,
    particular: "Sum Insured (₹)",
    pratham:
      "₹5L / ₹7.5L / ₹10L / ₹15L / ₹20L / ₹25L / ₹50L / ₹100L / ₹200L / ₹300L",
  },
  {
    id: 2,
    particular: "Room Accommodation",
    pratham: "Single Private A/C Room ICU - Covered up to Sum Insured",
  },
  {
    id: 3,
    particular: "Day Care Treatment",
    pratham:
      "All Day Care Procedure related to the listed condition, covered up to Sum Insured",
    uttam: "All Day Care Procedure covered up to Sum Insured.",
    isPrathamExpanded: true,
  },
  {
    id: 4,
    particular: "Pre Hospitalization Medical Expenses",
    pratham: "Up to 90 Days, Covered up to Sum Insured",
  },
  {
    id: 5,
    particular: "Post Hospitalization Medical Expenses",
    pratham: "Up to 180 Days, Covered up to Sum Insured",
  },
  {
    id: 6,
    particular: "Domiciliary Hospitalization",
    pratham: "Covered up Sum Insured.",
  },
  {
    id: 7,
    particular: "Road Ambulance",
    pratham: "Covered up Sum Insured.",
  },
  {
    id: 8,
    particular: "Donor Expenses",
    pratham:
      "Complications arising during hospitalization or up to 30 days from date of discharge - Up to 25% of SI subject to maximum of Rs. 2 Lacs, over and above Sum Insured",
  },
  {
    id: 9,
    particular: "AYUSH Treatment",
    pratham: "Covered up sum insured.",
  },
  {
    id: 10,
    particular: "Restoration of Sum Insured",
    pratham: "Available as Optional Cover",
    param: "Unlimited times for related/unrelated illnesses.",
    isParamExpanded: true,
  },
  {
    id: 11,
    particular: "Gullak (Guaranteed Cumulative Bonus)",
    pratham: "Available as Optional Cover",
    param:
      "100% guaranteed increase in Sum Insured, maximum up to 1500% irrespective of a claim under the Policy.",
    isParamExpanded: true,
  },
  {
    id: 12,
    particular: "Tele-Consultation",
    pratham:
      "Unlimited Tele-consultation with General Physician during the Policy Year.",
  },
  {
    id: 13,
    particular: "Wellness Benefit",
    pratham:
      "Earn rewards up to 20% of base premium through completing Healthy Life Management Program*",
  },
  {
    id: 14,
    particular: "Discount from Network Provider",
    pratham:
      "Discount on Pharmacy, Diagnostics and Health Supplements, offered by the Network Providers of ManipalCigna Health Insurance Company Limited",
  },
  {
    id: 15,
    particular: "Health Check-up",
    pratham: "Available as Optional Cover",
    uttam:
      "Annually from 1st year onwards, for all adults insured, offered through Network only.",
  },
  {
    id: 16,
    particular: "Accident Hospitalization Cover",
    pratham: "Covered up to Sum Insured",
    uttam: "Not Applicable (Available as part of Base Cover)",
  },
  {
    id: 17,
    particular: "Personal Accident Cover (₹)",
    pratham:
      "Coverage For Accidental Death (AD) , Permanent Total Disablement (PTD) And Permanent Partial Disablement (PPD) as per the Sum Insured Opted. Sum Insured - 10L, 15L, 20L, 25L, 30L, 40L, 50L, 1Cr, 2Cr, 3Cr Coverage of 200% of opted SI (If AD/PTD) occurs due to an Accident while travelling as a fare paying passenger on a common carrier.",
    isPrathamExpanded: true,
  },
  {
    id: 18,
    particular: "Temporary Total Disablement (TTD)(₹)",
    pratham: "Fixed Weekly benefit - 5K, 10K, 15K, 20K,25K, 50K,1L per week.",
  },
  {
    id: 19,
    particular: "Health Check-up",
    pratham:
      "Annually from 1st year onwards, for all adults insured, offered through Network only.",
    param: "Available as Base Cover",
  },
  {
    id: 20,
    particular: "Air Ambulance (₹)",
    pratham:
      "Covered up to Sum Insured, Max up to 10L, over and above Sum Insured",
  },
  {
    id: 21,
    particular: "Restoration of Sum Insured",
    pratham: "Unlimited times for related/unrelated illnesses",
    param: "Available in Base Cover",
  },
  {
    id: 22,
    particular: "Gullak Guaranteed Cumulative Bonus",
    pratham:
      "100% guaranteed increase in Sum Insured, maximum up to 1500% irrespective of a claim under the Policy.",
    param: "Available in Base Cover",
  },
  {
    id: 23,
    particular: "Maternity & New Born Hospitalization Expenses (₹)",
    pratham: "Not Available",
    uttam:
      "a. Maternity Cover: Covered up to 20% of Base Sum Insured Opted subject to a maximum 5Lac over and above the Sum Insured. b. New Born Baby: Coverage for the In-patient hospitalization expenses of a new born up to the limit provided under Maternity Expenses c. First Year Vaccination: Covered as per national immunization program, up to the limit provided under Maternity Expenses",
    param: "Not Available",
    isUttamExpanded: true,
  },
  {
    id: 24,
    particular: "Sarathi",
    pratham:
      "Any hospitalization related to Cancer, Heart, Stroke, & Major Organ/ Bone Marrow Transplant will be covered after the first 30 days, if arising due to listed Pre-existing disease declared and accepted. i. Asthma ii. Diabetes iii. Dyslipidemia iv. Obesity v. Hypertension",
    uttam:
      "Any hospitalization will be covered after the first 30 days, if arising due to listed Pre-existing disease declared and accepted. i. Asthma ii. Diabetes iii. Dyslipidemia iv. Obesity v. Hypertension v. Hypertension",
    param: "Not Available",
    isPrathamExpanded: true,
    isUttamExpanded: true,
    isInfo: true,
    tooltipContentTitle: "This is a tooltip",
    tooltipContentBody:
      "Tooltips are used to describe or identify an element. In most scenarios, tooltips help the user understand the meaning, function or alt-text of an element.",
  },
  {
    id: 25,
    particular: "Room Rent Modification",
    pratham:
      "Option 1: Any room; ICU Up to Sum Insured or Option 2: Twin Sharing AC room; ICU Up to Sum Insured",
  },
  {
    id: 26,
    particular: "Surplus",
    pratham:
      "Get an additional 100% of the Sum Insured available from day 1 for 1st claim only, in each policy year.",
  },
  {
    id: 27,
    particular: "Anant (Unlimited Sum Insured)",
    pratham: "Not Available",
    uttam:
      "No Limit for any hospitalization related to Cancer, Heart condition, Stroke or Major Organ/ Bone Marrow Transplant",
    param: "Not available",
    isUttamExpanded: true,
  },
  {
    id: 28,
    particular: "Deductible Option (₹)",
    pratham:
      "Option 1 – Aggregate Deductible 10K, 25K, 50K, 1L, 2L, 3L, 4L, 5L, 10L. Or Option 2 – Deductible of 1K, 2K, 3K, 4K, 5K per day of hospitalization on all admissible claims.",
  },
  {
    id: 29,
    particular: "Voluntary Co-payment",
    pratham:
      "10%, 20%, 30% (The cost sharing percentage that you have opted will apply on each and every claim.)",
  },
  {
    id: 30,
    particular: "Coverage for Non-Medical Items and Durable Medical Equipment",
    pratham:
      "a. Non-Medical items: Covered up to Sum Insured b. Durable Medical Equipment: Covered up to Rs.1 Lac.",
  },
  {
    id: 31,
    particular: "Pratiksha",
    pratham: "Not Applicable",
    param:
      "Specific Waiting Period: 24 Months, Initial Waiting Period: 30 Days",
    isParamExpanded: true,
  },
];

export default planComparisonData;
